module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isDark) ? _c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../assets/history.svg"),
      "alt": "history"
    }
  }) : (_vm.isGrey) ? _c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../assets/historyGrey.svg"),
      "alt": "history"
    }
  }) : _c('img', {
    staticClass: "position-relative",
    attrs: {
      "src": require("../../assets/historyLight.svg"),
      "alt": "history"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66713550","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/history/HistoryIcon.vue
// module id = 3238
// module chunks = 0